module.exports = __webpack_public_path__ + "img/banner-campaign.23793c57.svg";